import React, { useState } from "react";
import Style from "./Accardion10.module.scss";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import { BookmarkCheckFill,ChevronLeft } from "react-bootstrap-icons";

const Accardion10 = () => {
  const [openAll, setOpenAll] = useState(false)

  const ItemList = [
    {
      id: "1",
      title: "واریزی ها",
      link: "/income",
      active: window.location.pathname === "/income",
    },
    {
      id: "2",
      title: "برداشتی ها",
      link: "/outcome",
      active: window.location.pathname === "/outcome",
    },
  ]

  let value = false;
  ItemList.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });

  const openHandlerAll = () => {
    if (openAll) {
      setOpenAll(false);
    } else {
      setOpenAll(true);
    }
  };
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>حسابداری </p>
          <BookmarkCheckFill />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={ItemList && ItemList} />
      </div>
    </div>
  );
};

export default Accardion10;
